import { navigate } from "gatsby";
import React, { useEffect, useRef, useState } from "react";
import Clm2Img from "../../assets/Icons/mail.svg";
import Clm1Img from "../../assets/Icons/phone.svg";
import Layout from "../../components/layouts/layout";
import DataService from "../../services/api/data_services";
import { BASE_SITE_URL } from "../../shared/constants";
import Box from "../../templates/Box";
import TwoColumnContactInfo from "../../templates/TwoColumnContactInfo";
import ArticleBlog from "../../components/articleBlog";
import TableContent from "../../components/articleBlog/tableContent";

const Article = ({ pageContext: { article } }) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [articleRawData, setArticleRawData] = useState([]);
  const [articleData, setArticleData] = useState([]);
  const [articleContent, setArticleContent] = useState([]);
  const [articleTag, setArticleTag] = useState([]);
  const queryString =
    typeof window !== "undefined" ? window.location.href.split("/")[4] : "";
  const [isHover, setIsHover] = useState(false);
  const toggleHover = () => {
    setIsHover(!isHover);
  };
  // custom hook for getting previous value
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }
  const prevCount = usePrevious(articleData);
  useEffect(() => {
    setLimit(6);
    setPage(1);
    setArticleData([]);
    setArticleRawData([]);
    DataService.getData(`/admin/api/post-details?slug=${queryString}`).then(
      (response) => {
        fetchRelatedArtciles(response.data.tag_lists, response.data.id);
        const articleContent = response.data;
        setArticleContent(articleContent);
        setArticleTag(response.data.article_tag);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryString]);
  useEffect(() => {
    DataService.getData(`/admin/api/post-details?slug=${queryString}`).then(
      (response) => {
        fetchRelatedLoadmoreArtciles(response.data.tag_lists, response.data.id);
        const articleContent = response.data;
        setArticleContent(articleContent);
        setArticleTag(response.data.article_tag);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit, page]);
  // console.log("articleContent :>> ", articleContent);
  const fetchRelatedLoadmoreArtciles = (queryVal, id) => {
    let value = queryVal?.map((val) => `article_type[]=${val}`).join("&");
    DataService.getData(
      `/admin/api/article-tag-multiple?limit=${limit}&page=${page}&current_id=${id}&type=Article&${value}`
    ).then((response) => {
      setArticleData([...articleData, ...response.data]);
      setArticleRawData(response);
    });
  };
  const fetchRelatedArtciles = (queryVal, id) => {
    let value = queryVal?.map((val) => `article_type[]=${val}`).join("&");
    DataService.getData(
      `/admin/api/article-tag-multiple?limit=${limit}&page=${1}&current_id=${id}&type=Article&${value}`
    )
      .then((response) => {
        if (prevCount === undefined || response.data) {
          setArticleData(response.data);
          setArticleRawData(response);
        } else {
          setArticleData([...articleData, ...response.data]);
          setArticleRawData(response);
        }
      })
      .catch((error) => {
        navigate(-1);
      });
  };

  /**
   * TwoColumnContactInfo
   */
  const TwoColumnContactInfoData = {
    Clm1Img: Clm1Img,
    Clm1Title: "Phone:",
    Clm1SubTitle: "+44 (0) 161 706 7983",
    Clm2Img: Clm2Img,
    Clm2Title: "Email:",
    Clm2SubTitle: "hello@digiryte.com",
  };
  /**
   * Box component
   */
  const BoxData = {
    boxBtn1Width: "230px",
    boxBtn1Height: "46px",
    boxBtn1variant: "contained",
    boxBtn1color: "primary",
    boxBtn1label: "CAREER",
    boxBtn1Title: "Join our team",
    Clm2SubTitle: "careers@digiryte.com",
    boxBtn1SubTitle:
      "Here, you’re not “just” a developer or a designer! Take a step forward and join us!",
    boxBtn2Width: "230px",
    boxBtn2Height: "46px",
    boxBtn2variant: "contained",
    boxBtn2color: "primary",
    boxBtn2label: "GET IN TOUCH",
    boxBtn2Title: "Let's talk",
    boxBtn2SubTitle: "We'd love to help with your product.",
    route1: "/contact-us",
    route2: "/contact-us",
  };
  /**
   * Image avatar component
   */
  const imageAvatarData = {
    image: articleContent.author_image,
    alt: articleContent.author_name,
    name: articleContent.author_name,
    date: articleContent.published_date,
    title: articleContent.position,
  };

  const [processedContent, setProcessedContent] = useState("");

  useEffect(() => {
    if (articleContent?.body_content) {
      const updatedContent = addHeadingIds(articleContent?.body_content);
      console.log("Processed Content:", updatedContent); // Debugging
      setProcessedContent(updatedContent);
    }
  }, [articleContent?.body_content]);

  const addHeadingIds = (htmlContent) => {
    let index = 0; // Unique ID counter

    return htmlContent.replace(
      /<b>(#{2,3})\s*([^<]+)<\/b>/g,
      (_, hashes, text) => {
        const level = hashes.length; // ## -> h2, ### -> h3
        const id = `heading-${index++}`;
        return `<h${level} class="toc${level} ${
          level === 2 ? "title-underline" : ""
        }" id="${id}">${text.trim().replace(/^#{2,3}\s*/, "")}</h${level}>`;
      }
    );
  };

  return (
    <Layout
      seo={{
        title: article?.title,
        ogtitle: article?.og_title,
        description: article
          ? article.og_description
          : articleContent?.og_description,
        ogurl: `${BASE_SITE_URL}/article/${article?.slug}/`,
        ogimage: article?.og_image,
      }}
    >
      {/* header */}
      {articleContent && articleContent.body_content && (
        <ArticleBlog objectVal={articleContent} />
      )}

      <div className="mt-50 body-container">
        <TableContent
          articleContent={articleContent}
          objectData={articleData}
          content={processedContent}
        />
      </div>
      <div className="mt-400"></div>
      {articleData && articleData.length > 0 && (
        <div className="articles-blog-footer">
          <Box BoxData={BoxData} />
        </div>
      )}
      {articleData && articleData.length > 0 && (
        <div>
          <TwoColumnContactInfo
            TwoColumnContactInfoData={TwoColumnContactInfoData}
          />
        </div>
      )}
    </Layout>
  );
};
export default Article;
